$(function() {

    // ブログ　いいね
    $('.js-blog-goodTrigger').click(function (e) {
        e.preventDefault();

        const apiUrl = $(this).data('api-url');
        const blogId = $(this).data('blog-id');

        $.post(apiUrl).done(function (response) {
            if (response.status) {
                if (response.good) {
                    $(`.js-blog-goodTrigger[data-blog-id=${blogId}]`)
                        .addClass('icn-like-on')
                        .removeClass('icn-like-off');

                    const countEle = $(`.js-blog-goodCount[data-blog-id=${blogId}]`);
                    countEle.text(parseInt(countEle.text()) + 1);
                } else {
                    $(`.js-blog-goodTrigger[data-blog-id=${blogId}]`)
                        .removeClass('icn-like-on')
                        .addClass('icn-like-off');
                        
                    const countEle = $(`.js-blog-goodCount[data-blog-id=${blogId}]`);
                    countEle.text(parseInt(countEle.text()) - 1);
                }
            } else {
                alert(response.message);
            }
        }).fail(function () {
            alert('いいねできませんでした。');
        });
    });

    // ブログ　お気に入り
    $('.js-blog-favoriteTrigger').click(function (e) {
        e.preventDefault();

        const apiUrl = $(this).data('api-url');
        const blogId = $(this).data('blog-id');

        var $liEle = $(this).parents('.list-article-blogs-contents');
        var $listCountEle = $('#listFavoriteCount');
        var $favoriteSwitchEle = $('#filterForm input[name="favorite"]')[0];

        $.post(apiUrl).then(function (response) {
            if (response.status) {
                if (response.favorite) {
                    $(`.js-blog-favoriteTrigger[data-blog-id=${blogId}]`)
                        .addClass('icn-heart-on')
                        .removeClass('icn-heart-off');

                    const countEle = $(`.js-blog-favoriteCount[data-blog-id=${blogId}]`);
                    countEle.text(parseInt(countEle.text()) + 1);
                    if ($listCountEle) {
                        $listCountEle.text(parseInt($listCountEle.text()) + 1);
                    }
                } else {
                    $(`.js-blog-favoriteTrigger[data-blog-id=${blogId}]`)
                        .removeClass('icn-heart-on')
                        .addClass('icn-heart-off');

                    const countEle = $(`.js-blog-favoriteCount[data-blog-id=${blogId}]`);
                    countEle.text(parseInt(countEle.text()) - 1);
                    if ($listCountEle) {
                        $listCountEle.text(parseInt($listCountEle.text()) - 1);
                    }
                    
                    if ($favoriteSwitchEle && $favoriteSwitchEle.checked) {
                        $liEle.remove();
                    }
                }
            } else {
                alert(response.message);
            }
        }).fail(function () {
            alert('お気に入りできませんでした。');
        });
    });

    // コメント入力
    $('.js-blog-commentOpen').click(function () {
        const blogId = $(this).data('blog-id');
        $(`.js-blog-commentForm[data-blog-id=${blogId}]`).show();
    });

    // コメントキャンセル
    $('.js-blog-commentCancel').click(function () {
        const blogId = $(this).data('blog-id');
        $(`.js-blog-commentForm[data-blog-id=${blogId}] [name=comment]`).val('');
        $(`.js-blog-commentForm[data-blog-id=${blogId}]`).hide();
    });

    // コメント返信入力
    $('.js-blog-replyOpen').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-blog-replyForm[data-reply-id=${replyId}]`).show();
    });

    // コメント返信キャンセル
    $('.js-blog-replyCancel').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-blog-replyForm[data-reply-id=${replyId}] [name=comment]`).val('');
        $(`.js-blog-replyForm[data-reply-id=${replyId}]`).hide();
    });

    // コメントもっと見る
    $('.js-blog-showMoreComments').click(function () {
        if ($('.js-blog-moreComments').is(':visible')) {
            $(this).text('もっと見る ▼');
        } else {
            $(this).text('閉じる ▲');
        }
        $('.js-blog-moreComments').slideToggle();
    });

    // コメント送信のバリデーション
    $('.js-blog-commentForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-blog-commentForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // コメント返信のバリデーション
    $('.js-blog-replyForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-blog-replyForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // ブログ一覧　絞り込み
    $(function() {
        $('.js-filterItem').click(function() {
            var dataKey = $(this).data('key');

            console.log(dataKey);

            if (dataKey == 'all') {
                $('[name="category_ids[]"]').prop('checked', false);
            }

            $('#filterForm').submit();
        });
    });

    // ブログ一覧　コメントする
    $('.js-blog-commentLink').click(function (e) {
        e.preventDefault();
        var link = $(this).data('link');
        window.location.href = link;
    });
});